import { render } from "./ListeApropos.vue?vue&type=template&id=ae431932&ts=true"
import script from "./ListeApropos.vue?vue&type=script&lang=ts"
export * from "./ListeApropos.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__